import React from 'react';
import { useKeenSlider } from 'keen-slider/react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import 'keen-slider/keen-slider.min.css';

export default function EventsSection() {
    const eventsData = [
        {
            id: 1,
            day: "17",
            date: "Jun, 2026",
            title: "Mobikode at Google Cloud Summit London 2026",
            location: "Tobacco Dock, London"
        },
        {
            id: 2,
            day: "17",
            date: "Jun, 2026",
            title: "Mobikode at Google Cloud Summit London 2026",
            location: "Tobacco Dock, London"
        },
        {
            id: 3,
            day: "17",
            date: "Jun, 2026",
            title: "Mobikode at Google Cloud Summit London 2026",
            location: "Tobacco Dock, London"
        },
        {
            id: 4,
            day: "17",
            date: "Jun, 2026",
            title: "Mobikode at Google Cloud Summit London 2026",
            location: "Tobacco Dock, London"
        }
    ];

    const [sliderRef, instanceRef] = useKeenSlider(
        {
            initial: 0,
            loop: true,
            mode: "snap",
            slides: {
                perView: 1.1,
                spacing: 16,
            },
            breakpoints: {
                '(min-width: 640px)': {
                    slides: { perView: 2, spacing: 20 },
                },
                '(min-width: 1024px)': {
                    slides: { perView: 3, spacing: 24 },
                },
            },
        },
        [
            (slider) => {
                let timeout;
                let mouseOver = false;

                function clearNextTimeout() {
                    clearTimeout(timeout);
                }

                function nextTimeout() {
                    clearTimeout(timeout);
                    if (mouseOver) return;
                    timeout = setTimeout(() => {
                        slider.next();
                    }, 3000);
                }

                slider.on("created", () => {
                    slider.container.addEventListener("mouseover", () => {
                        mouseOver = true;
                        clearNextTimeout();
                    });
                    slider.container.addEventListener("mouseleave", () => {
                        mouseOver = false;
                        nextTimeout();
                    });
                    nextTimeout();
                });
                slider.on("animationEnded", nextTimeout);
                slider.on("updated", nextTimeout);
            },
        ]
    );

    return (
        <section className="bg-white pb-12 sm:pb-16 lg:pb-24 select-none text-left relative z-10 overflow-hidden">
            <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] w-full">

                <div className="mb-8 sm:mb-12 px-1 text-center">
                    <h2 className="text-[#01386A] font-sora font-[600] text-[20px] md:text-[30px] tracking-tight">
                        Events
                    </h2>
                </div>

                <div className="w-full overflow-hidden">
                    <div ref={sliderRef} className="keen-slider !overflow-visible">
                        {eventsData.map((event) => (
                            <div key={event.id} className="keen-slider__slide">
                                <div className="w-full bg-[#F0F0F0] p-6 sm:p-8 lg:p-10 flex flex-col justify-between min-h-[340px] sm:min-h-[380px] lg:min-h-[420px] transition-all duration-500 ease-out rounded-[2px] cursor-pointer group hover:bg-[#01386A] hover:text-white relative">

                                    <div className="space-y-1">
                                        <span className="text-[24px] sm:text-[40px] font-[500] font-graphik text-[#ED6800] block leading-none transition-colors duration-500">
                                            {event.day}
                                        </span>
                                        <span className="text-[14px] sm:text-[16px] font-[500] font-graphik text-[#ED6800] block tracking-wide uppercase transition-colors duration-500">
                                            {event.date}
                                        </span>
                                    </div>

                                    <div className="space-y-3 sm:space-y-4 mt-auto mb-8 sm:mb-12">
                                        <h3 className="font-sora font-[600] text-[16px] lg:text-[20px] leading-[1.35] tracking-tight group-hover:text-white text-[#01386A] transition-colors duration-500 line-clamp-3">
                                            {event.title}
                                        </h3>
                                        <p className="text-[#49577A] group-hover:text-gray-300 text-[14px] lg:text-[16px] font-[500] font-graphik transition-colors duration-500">
                                            {event.location}
                                        </p>
                                    </div>

                                    <div className="pt-2">
                                        <a
                                            href="#"
                                            className="inline-flex items-center gap-1.5 font-graphik text-[13px] sm:text-[16px] font-[600] border-b-2 border-transparent pb-0.5 group-hover:text-white group-hover:border-white text-[#01386A] border-[#01386A] transition-all duration-500 group/link"
                                        >
                                            <span>Register Now</span>
                                            <span className="transform transition-transform duration-300 group-hover/link:translate-x-1 text-orange-500 font-bold">
                                                &gt;
                                            </span>
                                        </a>
                                    </div>

                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="flex items-center gap-3 mt-8 sm:mt-12 px-1">
                    <button
                        onClick={(e) => e.stopPropagation() || instanceRef.current?.prev()}
                        className="w-8 h-8 sm:w-10 sm:h-10 rounded-full border border-orange-400 flex items-center justify-center text-orange-500 hover:bg-orange-50 active:scale-95 transition-all duration-200 cursor-pointer outline-none"
                    >
                        <ChevronLeft className="w-4 h-4 sm:w-5 sm:h-5 stroke-[2.5]" />
                    </button>
                    <button
                        onClick={(e) => e.stopPropagation() || instanceRef.current?.next()}
                        className="w-8 h-8 sm:w-10 sm:h-10 rounded-full border border-orange-400 flex items-center justify-center text-orange-500 hover:bg-orange-50 active:scale-95 transition-all duration-200 cursor-pointer outline-none"
                    >
                        <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 stroke-[2.5]" />
                    </button>
                </div>

            </div>
        </section>
    );
}